<nav>
  <kb-select on="background" floating [standalone]="true">
    @for (language of languages; track language.code) {
      <kb-select-option [value]="language">
        <ng-template><abbr [attr.lang]="language.code" [attr.title]="language.nativeName">{{ language.code | uppercase }}</abbr></ng-template>
      </kb-select-option>
    }
  </kb-select>
</nav>
<!--
  It would be much better to do it this way:
-->
<!--
<nav>
  <ul>
    <li class="selected"><abbr lang="en" title="English">EN</abbr></li>
    <li><a href="/de/" hreflang="de"><abbr lang="de" title="Deutsch">DE</abbr></a></li>
  </ul>
</nav>
-->
